import React from 'react';

const Tag = (tag) => {
  return <p>{tag.tag.name}</p>;
};
export default Tag;



// WEBPACK FOOTER //
// ./src/Components/Dishes/DishesList/Tag.jsx